import {
  BsFill1CircleFill,
  BsFill1SquareFill,
  BsFill2CircleFill,
  BsFill2SquareFill,
  BsFill3CircleFill,
  BsFill3SquareFill,
} from "react-icons/bs";
import "./Stepper.css";
import { useEffect, useState } from "react";
import Canvas from "./Canvas";
import StepOne from "./StepperPages/StepOne";
import StepThree from "./StepperPages/StepThree";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import { useCurrentUser } from "../context/UserContext";

const Stepper = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const { currentUser } = useCurrentUser();
  const handleKeyDown = (event: any) => {
    switch (event.key) {
      case "ArrowLeft":
        if (currentStep > 1) {
          setCurrentStep(currentStep - 1);
        }
        break;
      case "ArrowRight":
        if (currentStep < 3) {
          setCurrentStep(currentStep + 1);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentStep]);

  const renderSteps = () => {
    switch (currentStep) {
      case 1:
        return <StepOne />;
      case 2:
        return <Canvas />;
      case 3:
        if (analytics) {
          logEvent(analytics, "page_three", { user: currentUser?.email });
        }
        return <StepThree />;
      default:
        return null;
    }
  };

  const setActive = (step: number) => {
    if (step === currentStep) {
      return "active";
    } else if (step < currentStep) {
      return "completed";
    } else {
      return "inactive";
    }
  };

  return (
    <div className="blue-background">
      {renderSteps()}
      <div className="onboarding-container">
        <div className="progress-bar">
          <button
            className={`stepper-button ${setActive(1)}`}
            onClick={() => setCurrentStep(1)}
          >
            <BsFill1SquareFill />
          </button>
          <button
            className={`stepper-button ${setActive(2)}`}
            onClick={() => setCurrentStep(2)}
          >
            <BsFill2SquareFill />
          </button>
          <button
            className={`stepper-button ${setActive(3)}`}
            onClick={() => setCurrentStep(3)}
          >
            <BsFill3SquareFill />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
